import {HttpModelConverter} from "../../../../../../core/converter/httpModel.converter";
import {FormValueModel} from "../formValue.model";
import {Injectable} from "@angular/core";
import {FormDefinitionFieldConverter} from "../../../../../definition/field/api/entity/converter/formDefinitionField.converter";

@Injectable()
export class FormValueConverter extends HttpModelConverter<FormValueModel> {

    constructor(private definitionFieldConverter: FormDefinitionFieldConverter) {
        super();
    }

    protected createInstance(): FormValueModel {
        return new FormValueModel();
    }

    protected enrichObject(result: FormValueModel, src: FormValueModel) {
        result.fieldDefinition = this.definitionFieldConverter.convert(src.fieldDefinition);
    }
}